import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from "react";
import { CheckCircle } from "lucide-react";
import "../styles/Notification.css";

interface NotificationContextType {
  showNotification: (message: string) => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(
  undefined
);

export const NotificationProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [message, setMessage] = useState<string | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  const showNotification = (msg: string) => {
    setMessage(msg);
    setIsVisible(true);

    setTimeout(() => {
      setIsVisible(false);
    }, 2000);
  };

  useEffect(() => {
    if (!isVisible) {
      const timer = setTimeout(() => setMessage(null), 300);
      return () => clearTimeout(timer);
    }
  }, [isVisible]);

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}

      <div className={`notification-toast ${isVisible ? "show" : ""}`}>
        <CheckCircle size={20} className="notification-icon" />
        <span>{message}</span>
      </div>
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context)
    throw new Error(
      "useNotification must be used within a NotificationProvider"
    );
  return context;
};
